import { useState } from 'react';
import { Button, ButtonSizeXL, ButtonVariants, ButtonSkinMarket } from '@picsart/button';
import { Text } from '@picsart/text';
import IconAuto from '@picsart/icons/IconAuto';
import IconLoading from '@picsart/icons/IconLoading';
import { useTranslation } from 'react-i18next';
import { FontWeights, Typography } from '@picsart/cascade';

import getCompliment from '../../../utils/common/compliment';

import useStyles from './buttonStyles';
import { State } from './types';

export function GenerateButton() {
  const classes = useStyles();
  const { t } = useTranslation();
  const [state, setState] = useState<State>(State.Initial);
  const [result, setResult] = useState('');

  switch (state) {
    case State.Loading: {
      return (
        <Button
          className={classes.button}
          size={ButtonSizeXL}
          variant={ButtonVariants.Filled}
          skin={ButtonSkinMarket}
          isDisabled
        >
          <IconLoading className={classes.loader} />
        </Button>
      );
    }
    case State.Loaded: {
      return (
        <Text className={classes.result} size={Typography.t5} weight={FontWeights.SemiBold}>
          {result}
        </Text>
      );
    }
    default: {
      return (
        <Button
          className={classes.button}
          size={ButtonSizeXL}
          variant={ButtonVariants.Filled}
          skin={ButtonSkinMarket}
          startIcon={IconAuto}
          onClick={() => getCompliment({ setState, setResult })}
        >
          {t('generalLanding.genExample.btnGen')}
        </Button>
      );
    }
  }
}

export default GenerateButton;
